import styled from 'styled-components'

export const GridWrapper = styled.div`
display: grid;
gap: 20px;
grid-template-columns: 60px 1fr 60px;
grid-template-rows: repeat(2,min-content);
`;